export default __webpack_public_path__ + "static/image06-2a035f8ba31be56e7bbadce64c6f104a.webp";